import cookie from 'react-cookies';

const access_token =
  cookie.load('session') && cookie.load('session').access_token;

export const CONFIG = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${access_token && access_token}`,
  },
};
